import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {MessageBubble, translate} from 'views/module';

import userUtil from 'utils/miscellaneous/user/user_util';
import moment from 'moment';

const ChatMessageList = (props) => {
  const {
    selectedChatMessages,
    selectedParticipantRn,
  } = props;

  return (
    <Stack sx={{gap: 1}}>
      {
        selectedChatMessages.map((message) => {
          const isCaregiver = message.requesterRn === selectedParticipantRn;
          const requesterName = userUtil.getFullName(
              message.requester?.firstName,
              message.requester?.lastName,
          ).trim() || translate('case.Communication.Chat.UnknownSender');

          return (
            <MessageBubble
              key={message.messageRn || `${message.requesterRn}-${message.createdAt}`}
              isOwn={isCaregiver}
              fullName={requesterName}
              timestampLabel={message.createdAt ? moment(message.createdAt).format('MMM D, h:mm A') : ''}
              messageText={message.messageText}
              files={message.files}
            />
          );
        })
      }
    </Stack>
  );
};

ChatMessageList.propTypes = {
  selectedChatMessages: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedParticipantRn: PropTypes.string,
};

export default React.memo(ChatMessageList);
